module.exports = __webpack_public_path__ + "img/snow.5aadd661.svg";